import { combineReducers } from "redux";

import Auth from "./auth/reducers";
import Layout from "./layout/reducers";
import Language from "./language/reducers";
import Country from "./country/reducers";
import Users from "./users/reducers";
import Products from "./products/reducers";
import Expeditions from "./expeditions/reducers";
import Requests from "./requests/reducers";
import Affiliates from "./affiliates/reducers";
import Orders from "./orders/reducers";
import Shippings from "./shippings/reducers";
import Invoices from "./invoices/reducers";
import Analytics from "./analytics/reducers";
import Packages from "./pack/reducers";
import Logs from "./logs/reducers";
import Notifications from "./notifications/reducers";
import Integration from "./integration/reducers";
import TransferOrders from "./transferOrders/reducers";
import Boutique from "./boutique/reducers";

export default combineReducers({
  Auth,
  Layout,
  Language,
  Country,
  Users,
  Products,
  Expeditions,
  Requests,
  Affiliates,
  Orders,
  Shippings,
  Invoices,
  Analytics,
  Packages,
  Logs,
  Notifications,
  Integration,
  TransferOrders,
  Boutique,
});
